import { FunctionComponent } from 'react'

import { Navigate, Route, Routes } from 'react-router-dom'
import { withErrorBoundary } from '@sentry/react'

import { APP } from 'src/Configs/App'
import { PublicRoutesEnum } from 'src/Router/PublicComponentsNewUI'
import { PreReleaseRedirect } from 'src/Router/PreReleaseRedirect'
import { CampaignsListPage } from 'src/Pages/Artist/CampaignsListPage'
import { SpotifyCampaignDetailsPage } from 'src/Pages/Artist/SpotifyCampaignDetailsPage'
import { SpotifySchedulePage } from 'src/Pages/Artist/SpotifySchedulePage'
import { TiktokSchedulePage } from 'src/Pages/Artist/TiktokSchedulePage'
import { AdsSchedulePage } from 'src/Pages/Artist/AdsSchedulePage'
import { TiktokCampaignDetailsPage } from 'src/Pages/Artist/TiktokCampaignDetailsPage'
import { TikTokVideoDetailsPage } from 'src/Pages/Artist/TikTokVideoDetailsPage'
import { ArtistBalancePage } from 'src/Pages/Artist/ArtistBalancePage'
import { Subscriptions } from 'src/Pages/Artist/SubscriptionsPage'
import { PaySubscription } from 'src/Pages/Artist/SubscriptionsPage/PaySubscription/PaySubscription'
import { SuccessPaymentSubscription } from 'src/Pages/Artist/SubscriptionsPage/SuccessPaymentSubscription'
import { CancelSubscription } from 'src/Pages/Artist/SubscriptionsPage/CancelSubscription'
import { ReferAndEarnPage } from 'src/Pages/Artist/ReferAndEarnPage'
import { SettingsPage } from 'src/Pages/Artist/SettingsPage'
import { ExpiredLinkPage } from 'src/Pages/Artist/ExpiredLinkPage'
import { ChoosePlatformAuthPage } from 'src/Pages/Artist/CreateCampaignPage/AuthPages/ChoosePlatformAuthPage'
import { SearchTrackAuth } from 'src/Pages/Artist/CreateCampaignPage/AuthPages/SearchTrackAuth'
import { Survey } from 'src/Pages/Artist/Survey'
import { SuccessCreatedFirst } from 'src/Pages/Artist/SuccessCreatedFirst'
import { SelectedTrackAuth } from 'src/Pages/Artist/CreateCampaignPage/AuthPages/SelectedTrackAuth'
import { ErrorComponent } from 'src/Components/ErrorBoundary/ErrorComponent'
import { MetaAdsCampaignDetailsPage } from 'src/Pages/Artist/MetaAdsCampaignDetailsPage'
import { CreateAdsCampaign } from 'src/Pages/Artist/CreateCampaignPage/AuthPages/CreateAdsCampaign'
import { SearchResourceAdsCampaign } from 'src/Pages/Artist/CreateCampaignPage/AuthPages/SearchResourceAdsCampaign'
import { ChooseReleaseTypeAuthPage } from 'src/Pages/Artist/CreateCampaignPage/AuthPages/ChooseReleaseTypeAuthPage'
import { PreReleaseTrackDetailsAuth } from 'src/Pages/Artist/CreateCampaignPage/AuthPages/PreReleaseTrackDetailsAuth'
import { SuccessCreatedFirstPreRelease } from 'src/Pages/Artist/SuccessCreatedFirstPreRelease'

const CampaignsListPageWithErrorBoundary = withErrorBoundary(
  CampaignsListPage,
  {
    fallback: <ErrorComponent />,
  },
)
const SpotifyCampaignDetailsPageWithErrorBoundary = withErrorBoundary(
  SpotifyCampaignDetailsPage,
  {
    fallback: <ErrorComponent />,
  },
)
const SpotifySchedulePageWithErrorBoundary = withErrorBoundary(
  SpotifySchedulePage,
  {
    fallback: <ErrorComponent />,
  },
)
const AdsSchedulePageWithErrorBoundary = withErrorBoundary(AdsSchedulePage, {
  fallback: <ErrorComponent />,
})

const TiktokSchedulePageWithErrorBoundary = withErrorBoundary(
  TiktokSchedulePage,
  {
    fallback: <ErrorComponent />,
  },
)
const TiktokCampaignDetailsPageWithErrorBoundary = withErrorBoundary(
  TiktokCampaignDetailsPage,
  {
    fallback: <ErrorComponent />,
  },
)
const TikTokVideoDetailsPageWithErrorBoundary = withErrorBoundary(
  TikTokVideoDetailsPage,
  {
    fallback: <ErrorComponent />,
  },
)
const PaySubscriptionWithErrorBoundary = withErrorBoundary(PaySubscription, {
  fallback: <ErrorComponent />,
})
const ArtistBalancePageWithErrorBoundary = withErrorBoundary(
  ArtistBalancePage,
  {
    fallback: <ErrorComponent />,
  },
)
const SubscriptionsWithErrorBoundary = withErrorBoundary(Subscriptions, {
  fallback: <ErrorComponent />,
})
const CancelSubscriptionWithErrorBoundary = withErrorBoundary(
  CancelSubscription,
  {
    fallback: <ErrorComponent />,
  },
)
const SuccessPaymentSubscriptionWithErrorBoundary = withErrorBoundary(
  SuccessPaymentSubscription,
  {
    fallback: <ErrorComponent />,
  },
)
const ExpiredLinkPageWithErrorBoundary = withErrorBoundary(ExpiredLinkPage, {
  fallback: <ErrorComponent />,
})
const ReferAndEarnPageWithErrorBoundary = withErrorBoundary(ReferAndEarnPage, {
  fallback: <ErrorComponent />,
})
const SettingsPageWithErrorBoundary = withErrorBoundary(SettingsPage, {
  fallback: <ErrorComponent />,
})
const SelectedTrackAuthWithErrorBoundary = withErrorBoundary(
  SelectedTrackAuth,
  {
    fallback: <ErrorComponent />,
  },
)
const CreateAdsCampaignAuthWithErrorBoundary = withErrorBoundary(
  CreateAdsCampaign,
  {
    fallback: <ErrorComponent />,
  },
)
const SuccessCreatedFirstWithErrorBoundary = withErrorBoundary(
  SuccessCreatedFirst,
  {
    fallback: <ErrorComponent />,
  },
)
const SuccessCreatedFirstPreReleaseWithErrorBoundary = withErrorBoundary(
  SuccessCreatedFirstPreRelease,
  {
    fallback: <ErrorComponent />,
  },
)
const SurveyWithErrorBoundary = withErrorBoundary(Survey, {
  fallback: <ErrorComponent />,
})
const SearchTrackAuthWithErrorBoundary = withErrorBoundary(SearchTrackAuth, {
  fallback: <ErrorComponent />,
})
const ChoosePlatformAuthPageWithErrorBoundary = withErrorBoundary(
  ChoosePlatformAuthPage,
  {
    fallback: <ErrorComponent />,
  },
)

const MetaAdsCampaignDetailsPageWithErrorBoundary = withErrorBoundary(
  MetaAdsCampaignDetailsPage,
  {
    fallback: <ErrorComponent />,
  },
)

const SearchTrackAdsCampaignWithErrorBoundary = withErrorBoundary(
  SearchResourceAdsCampaign,
  {
    fallback: <ErrorComponent />,
  },
)

const ChooseReleaseTypeAuthPageWithErrorBoundary = withErrorBoundary(
  ChooseReleaseTypeAuthPage,
  {
    fallback: <ErrorComponent />,
  },
)

const PreReleaseTrackDetailsAuthWithErrorBoundary = withErrorBoundary(
  PreReleaseTrackDetailsAuth,
  {
    fallback: <ErrorComponent />,
  },
)

export enum ArtistRoutesEnum {
  Root = '/',
  ChooseCreateCampaignPlatform = '/campaigns/new',
  ChooseCreateCampaignPlatformSpotify = '/campaigns/new/spotify',
  ChooseCreateCampaignReleaseType = '/campaigns/new/spotify/release-type',
  CreatePreReleaseTrackDetails = '/campaigns/new/spotify/track-details',
  ChooseCreateCampaignPlatformTikTok = '/campaigns/new/tiktok',
  CampaignsList = '/campaigns',
  TiktokDetails = '/campaigns/details',
  MetaAdsDetails = '/campaigns/ad-details',
  SpotifyDetails = '/campaigns/view',
  SpotifySchedule = '/campaigns/schedule',
  TiktokSchedule = '/campaigns/scheduleTikTok',
  New = '/new',
  Settings = '/settings',
  ReferAndEarn = '/refer-and-earn',
  Balance = '/balance',
  Subscription = '/subscription',
  SubscriptionPayment = '/subscription/pay',
  SubscriptionPaymentSuccess = '/subscription/pay/success',
  SubscriptionCancel = '/subscription/cancel',
  Errors = '/errors',
  Create = '/create',
  CreateSpotify = '/create/spotify',
  CreateAds = '/create/ads',
  CreateTikTok = '/create/tiktok',
  CreatedFirst = '/created-first',
  Feedback = '/feedback',
  SuccessCreated = '/created-first/:campaignType',
  SuccessCreatedPreRelease = '/created-first/spotify-pre-release/:campaignId',
  ReferralLinkNotExist = '/referral-link-not-exist',
  AdsSchedule = '/campaigns/scheduleAds',
}

const campaignsListRedirect = (
  <Navigate to={ArtistRoutesEnum.CampaignsList} replace />
)

interface GuestCreateCampaignRedirect {
  from: string
  to: string
}

export const getGuestCreateCampaignRedirects = (
  isPreReleaseEnabled: boolean,
): GuestCreateCampaignRedirect[] => [
  {
    from: PublicRoutesEnum.CreateSpotifyCampaignReleaseType,
    to: isPreReleaseEnabled
      ? ArtistRoutesEnum.ChooseCreateCampaignReleaseType
      : ArtistRoutesEnum.ChooseCreateCampaignPlatformSpotify,
  },
  {
    from: PublicRoutesEnum.CreatePreReleaseTrackDetails,
    to: isPreReleaseEnabled
      ? ArtistRoutesEnum.CreatePreReleaseTrackDetails
      : ArtistRoutesEnum.ChooseCreateCampaignPlatformSpotify,
  },
  {
    from: PublicRoutesEnum.CreateSpotifyCampaign,
    to: ArtistRoutesEnum.ChooseCreateCampaignPlatformSpotify,
  },
  {
    from: PublicRoutesEnum.CreateTikTokCampaign,
    to: ArtistRoutesEnum.ChooseCreateCampaignPlatformTikTok,
  },
]

export const ArtistComponentsNewUI: FunctionComponent = () => (
  <Routes>
    {getGuestCreateCampaignRedirects(APP.PRE_RELEASE_CAMPAIGNS_ENABLED).map(
      ({ from, to }) => (
        <Route
          key={from}
          path={from}
          element={<PreReleaseRedirect to={to} />}
        />
      ),
    )}
    <Route
      path={ArtistRoutesEnum.ChooseCreateCampaignReleaseType}
      element={
        APP.PRE_RELEASE_CAMPAIGNS_ENABLED ? (
          <ChooseReleaseTypeAuthPageWithErrorBoundary />
        ) : (
          campaignsListRedirect
        )
      }
    />
    <Route
      path={ArtistRoutesEnum.CreatePreReleaseTrackDetails}
      element={
        APP.PRE_RELEASE_CAMPAIGNS_ENABLED ? (
          <PreReleaseTrackDetailsAuthWithErrorBoundary />
        ) : (
          campaignsListRedirect
        )
      }
    />
    <Route
      path={`${ArtistRoutesEnum.ChooseCreateCampaignPlatform}/:platform/:trackId`}
      Component={SelectedTrackAuthWithErrorBoundary}
    />
    <Route
      path={`${ArtistRoutesEnum.Create}/:platform/:trackId`}
      Component={SelectedTrackAuthWithErrorBoundary}
    />
    <Route
      Component={ChoosePlatformAuthPageWithErrorBoundary}
      path={`${ArtistRoutesEnum.Create}`}
    />
    <Route
      path={`${ArtistRoutesEnum.CreateAds}`}
      Component={CreateAdsCampaignAuthWithErrorBoundary}
    />
    <Route
      path={`${ArtistRoutesEnum.CreateAds}/:strategy`}
      Component={SearchTrackAdsCampaignWithErrorBoundary}
    />
    <Route
      path={`${ArtistRoutesEnum.ChooseCreateCampaignPlatform}/:platform`}
      Component={SearchTrackAuthWithErrorBoundary}
    />
    <Route
      path={`${ArtistRoutesEnum.MetaAdsDetails}/:campaignID`}
      Component={MetaAdsCampaignDetailsPageWithErrorBoundary}
    />
    <Route
      Component={ChoosePlatformAuthPageWithErrorBoundary}
      path={`${ArtistRoutesEnum.ChooseCreateCampaignPlatform}`}
    />
    <Route
      path={ArtistRoutesEnum.SuccessCreated}
      Component={SuccessCreatedFirstWithErrorBoundary}
    />
    <Route
      path={ArtistRoutesEnum.SuccessCreatedPreRelease}
      element={
        APP.PRE_RELEASE_CAMPAIGNS_ENABLED ? (
          <SuccessCreatedFirstPreReleaseWithErrorBoundary />
        ) : (
          campaignsListRedirect
        )
      }
    />
    <Route
      Component={ExpiredLinkPageWithErrorBoundary}
      path={ArtistRoutesEnum.Errors}
    />

    <Route
      Component={SettingsPageWithErrorBoundary}
      path={ArtistRoutesEnum.Settings}
    >
      <Route path=':page' Component={SettingsPageWithErrorBoundary} />
    </Route>

    <Route
      Component={ReferAndEarnPageWithErrorBoundary}
      path={ArtistRoutesEnum.ReferAndEarn}
    />

    <Route
      Component={ArtistBalancePageWithErrorBoundary}
      path={ArtistRoutesEnum.Balance}
    />
    <Route
      Component={SubscriptionsWithErrorBoundary}
      path={ArtistRoutesEnum.Subscription}
    />
    <Route
      path={ArtistRoutesEnum.SubscriptionPayment}
      Component={PaySubscriptionWithErrorBoundary}
    />
    <Route
      path={ArtistRoutesEnum.SubscriptionPaymentSuccess}
      Component={SuccessPaymentSubscriptionWithErrorBoundary}
    />
    <Route
      path={ArtistRoutesEnum.SubscriptionCancel}
      Component={CancelSubscriptionWithErrorBoundary}
    />
    <Route
      Component={AdsSchedulePageWithErrorBoundary}
      path={`${ArtistRoutesEnum.AdsSchedule}/:number`}
    />
    <Route
      Component={TiktokSchedulePageWithErrorBoundary}
      path={`${ArtistRoutesEnum.TiktokSchedule}/:number`}
    />
    <Route
      Component={SpotifySchedulePageWithErrorBoundary}
      path={`${ArtistRoutesEnum.SpotifySchedule}/:number`}
    />
    <Route
      Component={SpotifyCampaignDetailsPageWithErrorBoundary}
      path={`${ArtistRoutesEnum.SpotifyDetails}/:campaignID`}
    />

    <Route path={`${ArtistRoutesEnum.TiktokDetails}`}>
      <Route
        path=':campaignID'
        Component={TiktokCampaignDetailsPageWithErrorBoundary}
      />
      <Route
        path=':campaignID/:videoID'
        Component={TikTokVideoDetailsPageWithErrorBoundary}
      />
    </Route>

    <Route Component={CampaignsListPageWithErrorBoundary} path='*' />
    <Route
      Component={CampaignsListPageWithErrorBoundary}
      path={ArtistRoutesEnum.Root}
    />
    <Route
      Component={CampaignsListPageWithErrorBoundary}
      path={ArtistRoutesEnum.CampaignsList}
    />
    <Route
      path={`${ArtistRoutesEnum.CreatedFirst}/:campaignType${ArtistRoutesEnum.Feedback}`}
      Component={SurveyWithErrorBoundary}
    />
    <Route
      path={`${ArtistRoutesEnum.CreatedFirst}${ArtistRoutesEnum.Feedback}`}
      Component={SurveyWithErrorBoundary}
    />
  </Routes>
)
